module.exports = __webpack_public_path__ + "static/media/globe-europe.1079dc38.svg";